export const LOGIN_START = "LOGIN_START";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT_START = "LOGOUT_START";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";

export const TRY_LOGIN_START = "TRY_LOGIN_START";
export const TRY_LOGIN_SUCCESS = "TRY_LOGIN_SUCCESS";
export const TRY_LOGIN_FAIL = "TRY_LOGIN_FAIL";

export const SAML_LOGIN_START = "SAML_LOGIN_START";
export const SAML_LOGIN_SUCCESS = "SAML_LOGIN_SUCCESS";
export const SAML_LOGIN_FAIL = "SAML_LOGIN_FAIL";

export const FORGOT_PASSWORD_START = "FORGOT_PASSWORD_START";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_FAIL = "FORGOT_PASSWORD_FAIL";

export const NEW_PASSWORD_START = "NEW_PASSWORD_START";
export const NEW_PASSWORD_SUCCESS = "NEW_PASSWORD_SUCCESS";
export const NEW_PASSWORD_FAIL = "NEW_PASSWORD_FAIL";

export const ACCOUNT_SETTINGS_FETCH_START = "ACCOUNT_SETTINGS_FETCH_START";
export const ACCOUNT_SETTINGS_FETCH_SUCCESS = "ACCOUNT_SETTINGS_FETCH_SUCCESS";
export const ACCOUNT_SETTINGS_FETCH_FAIL = "ACCOUNT_SETTINGS_FETCH_FAIL";
export const COMPANY_INFO_SAVE_START = "COMAPNY_INFO_SAVE_START";
export const COMPANY_INFO_SAVE_SUCCESS = "COMPANY_INFO_SAVE_SUCCESS";
export const COMPANY_INFO_SAVE_FAIL = "COMPANY_INFO_SAVE_FAIL";
export const COMPANY_INFO_SAVE_CANCEL = "COMPANY_INFO_SAVE_CANCEL";
export const SSO_CONFIG_SAVE_START = "SSO_CONFIG_SAVE_START";
export const SSO_CONFIG_SAVE_SUCCESS = "SSO_CONFIG_SAVE_SUCCESS";
export const SSO_CONFIG_SAVE_FAIL = "SSO_CONFIG_SAVE_FAIL";
export const SSO_CONFIG_SAVE_CANCEL = "SSO_CONFIG_SAVE_CANCEL";

export const INSTALLATION_FETCH_START = "INSTALLATION_FETCH_START";
export const INSTALLATION_FETCH_SUCCESS = "INSTALLATION_FETCH_SUCCESS";
export const INSTALLATION_FETCH_FAIL = "INSTALLATION_FETCH_FAIL";
export const EDIT_TAG_START = "EDIT_TAG_START";
export const EDIT_TAG_SUCCESS = "EDIT_TAG_SUCCESS";
export const EDIT_TAG_FAIL = "EDIT_TAG_FAIL";
export const REGEN_CF_START = "REGEN_CF_START";
export const REGEN_CF_SUCCESS = "REGEN_CF_SUCCESS";
export const REGEN_CF_FAIL = "REGEN_CF_FAIL";
export const SHOW_API_TOKEN_START = "SHOW_API_TOKEN_START";
export const SHOW_API_TOKEN_SUCCESS = "SHOW_API_TOKEN_SUCCESS";
export const SHOW_API_TOKEN_FAIL = "SHOW_API_TOKEN_FAIL";
export const SHOW_TERRAFORM_START = "SHOW_TERRAFORM_START";
export const SHOW_TERRAFORM_SUCCESS = "SHOW_TERRAFORM_SUCCESS";
export const SHOW_TERRAFORM_FAIL = "SHOW_TERRAFORM_FAIL";

export const ADD_CLOUD_ACCOUNT_START = "ADD_CLOUD_ACCOUNT_START";
export const ADD_CLOUD_ACCOUNT_SUCCESS = "ADD_CLOUD_ACCOUNT_SUCCESS";
export const ADD_CLOUD_ACCOUNT_FAIL = "ADD_CLOUD_ACCOUNT_FAIL";
export const EDIT_CLOUD_ACCOUNT_START = "EDIT_CLOUD_ACCOUNT_START";
export const EDIT_CLOUD_ACCOUNT_SUCCESS = "EDIT_CLOUD_ACCOUNT_SUCCESS";
export const EDIT_CLOUD_ACCOUNT_FAIL = "EDIT_CLOUD_ACCOUNT_FAIL";
export const DELETE_CLOUD_ACCOUNT_START = "DELETE_CLOUD_ACCOUNT_START";
export const DELETE_CLOUD_ACCOUNT_SUCCESS = "DELETE_CLOUD_ACCOUNT_SUCCESS";
export const DELETE_CLOUD_ACCOUNT_FAIL = "DELETE_CLOUD_ACCOUNT_FAIL";

export const ADD_USER_START = "ADD_USER_START";
export const ADD_USER_SUCCESS = "ADD_USER_SUCCESS";
export const ADD_USER_FAIL = "ADD_USER_FAIL";
export const EDIT_USER_START = "EDIT_USER_START";
export const EDIT_USER_SUCCESS = "EDIT_USER_SUCCESS";
export const EDIT_USER_FAIL = "EDIT_USER_FAIL";
export const DELETE_USER_START = "DELETE_USER_START";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_FAIL = "DELETE_USER_FAIL";
export const DELETE_APIKEY_START = "DELETE_APIKEY_START";
export const DELETE_APIKEY_SUCCESS = "DELETE_APIKEY_SUCCESS";
export const DELETE_APIKEY_FAIL = "DELETE_APIKEY_FAIL";
export const GENERATE_APIKEY_START = "GENERATE_APIKEY_START";
export const GENERATE_APIKEY_SUCCESS = "GENERATE_APIKEY_SUCCESS";
export const GENERATE_APIKEY_FAIL = "GENERATE_APIKEY_FAIL";
export const CHANGE_PASSWORD_START = "CHANGE_PASSWORD_START";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAIL = "CHANGE_PASSWORD_FAIL";
export const DELETE_SESSION_START = "DELETE_SESSION_START";
export const DELETE_SESSION_SUCCESS = "DELETE_SESSION_SUCCESS";
export const DELETE_SESSION_FAIL = "DELETE_SESSION_FAIL";
export const EDIT_SCOPING_START = "EDIT_SCOPING_START";
export const EDIT_SCOPING_SUCCESS = "EDIT_SCOPING_SUCCESS";
export const EDIT_SCOPING_FAIL = "EDIT_SCOPING_FAIL";

export const TOGGLE_WEEKLY_EMAIL_START = "TOGGLE_WEEKLY_EMAIL_START";
export const TOGGLE_WEEKLY_EMAIL_SUCCESS = "TOGGLE_WEEKLY_EMAIL_SUCCESS";
export const TOGGLE_WEEKLY_EMAIL_FAIL = "TOGGLE_WEEKLY_EMAIL_FAIL";

export const DASHBOARD_FETCH_START = "DASHBOARD_FETCH_START";
export const DASHBOARD_FETCH_SUCCESS = "DASHBOARD_FETCH_SUCCESS";
export const DASHBOARD_FETCH_FAIL = "DASHBOARD_FETCH_FAIL";

export const DASHBOARD_CHANGE_RESERVATION_TYPE = "DASHBOARD_CHANGE_RESERVATION_TYPE";

export const GCP_DASHBOARD_FETCH_START = "GCP_DASHBOARD_FETCH_START";
export const GCP_DASHBOARD_FETCH_SUCCESS = "GCP_DASHBOARD_FETCH_SUCCESS";
export const GCP_DASHBOARD_FETCH_FAIL = "GCP_DASHBOARD_FETCH_FAIL";

export const GCP_DASHBOARD_CHANGE_RESERVATION_TYPE = "GCP_DASHBOARD_CHANGE_RESERVATION_TYPE";

export const XOGROUPS_FETCH_START = "XOGROUPS_FETCH_START";
export const XOGROUPS_FETCH_SUCCESS = "XOGROUPS_FETCH_SUCCESS";
export const XOGROUPS_FETCH_FAIL = "XOGROUPS_FETCH_FAIL";
export const EDIT_XOGROUPS_START = "EDIT_XOGROUPS_START";
export const EDIT_XOGROUPS_SUCCESS = "EDIT_XOGROUPS_SUCCESS";
export const EDIT_XOGROUPS_FAIL = "EDIT_XOGROUPS_FAIL";
export const FETCH_GROUP_ACTIVITIES_START = "FETCH_GROUP_ACTIVITIES_START";
export const FETCH_GROUP_ACTIVITIES_SUCCESS = "FETCH_GROUP_ACTIVITIES_SUCCESS";
export const FETCH_GROUP_ACTIVITIES_FAIL = "FETCH_XOGROUP_ACTIVITIES_FAIL";
export const FETCH_GROUP_INSTANCES_START = "FETCH_GROUP_INSTANCES_START";
export const FETCH_GROUP_INSTANCES_SUCCESS = "FETCH_GROUP_INSTANCES_SUCCESS";
export const FETCH_GROUP_INSTANCES_FAIL = "FETCH_XOGROUP_INSTANCES_FAIL";

export const SCHEDULERS_FETCH_START = "SCHEDULERS_FETCH_START";
export const SCHEDULERS_FETCH_SUCCESS = "SCHEDULERS_FETCH_SUCCESS";
export const SCHEDULERS_FETCH_FAIL = "SCHEDULERS_FETCH_FAIL";
export const COPY_SCHEDULER_START = "COPY_SCHEDULER_START";
export const COPY_SCHEDULER_SUCCESS = "COPY_SCHEDULER_SUCCESS";
export const COPY_SCHEDULER_FAIL = "COPY_SCHEDULER_FAIL";
export const EDIT_SCHEDULER_START = "EDIT_SCHEDULER_START";
export const EDIT_SCHEDULER_SUCCESS = "EDIT_SCHEDULER_SUCCESS";
export const EDIT_SCHEDULER_FAIL = "EDIT_SCHEDULER_FAIL";

export const BUDGET_FETCH_START = "BUDGET_FETCH_START";
export const BUDGET_FETCH_SUCCESS = "BUDGET_FETCH_SUCCESS";
export const BUDGET_FETCH_FAIL = "BUDGET_FATCH_FAIL";
export const SAVE_BUDGET_START = "SAVE_BUDGET_START";
export const SAVE_BUDGET_SUCCESS = "SAVE_BUDGET_SUCCESS";
export const SAVE_BUDGET_FAIL = "SAVE_BUDGET_FAIL";

export const ALERTS_FETCH_START = "ALERTS_FETCH_START";
export const ALERTS_FETCH_SUCCESS = "ALERTS_FETCH_SUCCESS";
export const ALERTS_FETCH_FAIL = "ALERTS_FETCH_FAIL";